// Ensure the document is ready and jQuery is loaded
(function($) {
  $(document).ready(function() {

    console.log("test 4");

    // Check if URL contains the specific query string and hash
    if (window.location.search === '?contact_posted=true' && window.location.hash === '#contact_form') {
      $('html').addClass('open-lightbox');
    }

    // Handle clicking the buttons to show the lightbox
    $('.aw-show-lighbox').click(function () {
      // Get the department name from the clicked button's data attribute
      var departmentName = $(this).data('department'); // Use .data() which is preferred

      // Construct the value for the hidden field
      var departmentValue = departmentName ? departmentName + " Department" : "General Inquiry"; // Add " Department" and handle if data-attribute is missing

      // Find the hidden input field within the lightbox form and set its value
      $('#contact-department').val(departmentValue);

      // Show the lightbox
      $('html').addClass('open-lightbox'); // Use addClass instead of toggleClass to ensure it opens

      // If needed, specifically handle the 'show-all-field' class based on the button clicked
      // Example: check if the clicked button was the specific one (e.g., data-lightbox-item="2")
      if ($(this).data('lightbox-item') == 2) { // Check the specific attribute if needed
        $('html').addClass('show-all-field');
      } else {
         // Ensure 'show-all-field' is removed if other buttons are clicked
         $('html').removeClass('show-all-field');
      }

    });


    $('button[data-lightbox-item="2"]').click(function () {
      $('html').addClass('show-all-field');
    });

    $('.aw-close-lightbox').click(function () {
      $('html').removeClass('open-lightbox');
      $('html').removeClass('show-all-field');

      // Remove the query string and hash from the URL
      if (window.location.search === '?contact_posted=true' && window.location.hash === '#contact_form') {
        let cleanURL = window.location.href.split('?')[0];
        window.history.replaceState({}, document.title, cleanURL);

        // Force the page to reload
        window.location.reload();
      }
    });

    // Initialize Flickity carousel
    var $heroSlider = $('.hero-carousel').flickity({
      freeScroll: false,
      imagesLoaded: true,
      wrapAround: true,
      cellAlign: 'left',
      cellSelector: '.carousel-cell',
      groupCells: 1,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      lazyLoad: true,
      autoPlay: 6000,
      pauseAutoPlayOnHover: false
    });

    $heroSlider.show().flickity('resize');
    $('.frontpage-about .content-block').addClass('is-in-view');

    // Make sure this runs after initFlickitySlider()
    // var $heroSlider = $('.hero-carousel:not([data-flickity-slider])').flickity({
    //   freeScroll: false,
    //   imagesLoaded: true,
    //   wrapAround: true,
    //   cellAlign: 'left',
    //   cellSelector: '.carousel-cell',
    //   groupCells: 1,
    //   contain: true,
    //   pageDots: false,
    //   prevNextButtons: false,
    //   lazyLoad: true,
    //   autoPlay: 5000,
    //   pauseAutoPlayOnHover: true
    // });

    // $heroSlider.show().flickity('resize');

  });
})(jQuery); 
